module.exports = __webpack_public_path__ + "313811b3b723810a60cc611175967e7b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/group/Green1.jpg
// module id = 9
// module chunks = 0